module.exports = "# Sizzle\n\n## Content\n\n### Activité : Créer une affiche\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* Chaque membre de l'équipe dessine une affiche pour son domicile qui indiquera à sa famille les meilleurs moyens de réduire la pollution d'eau.\n* Consultez votre livre de missions pour trouver des moyens de réduire la pollution d'eau et choisissez-en au moins deux pour votre affiche.\n* Les apprenti(e)s recoivent des points quand leur affiche est terminée.\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/30_classActivity/level3_poster.fr_CA.md
// module id = 1701
// module chunks = 2